/*
 *
 * Copyright (C) 2022 NetBase Solutions, Inc.
 * 3960 Freedom Circle Suite 201 Santa Clara, CA 95054
 * All rights reserved.
 */

import React from 'react'
import { useTranslation } from 'react-i18next'
import { useDashboardWidgetData } from '../../../../hooks/useWidgetState'
import ErrorMessage from '../../../share/ErrorMessage'

// eslint-disable-next-line react/prop-types
const UnexpectedServiceErrorGuard = ({ widgetId, children }) => {
  const widgetData = useDashboardWidgetData(widgetId)
  const { t } = useTranslation()

  if (widgetData.status === 'failed')
    return <ErrorMessage>{t('unexpectedServiceError')}</ErrorMessage>

  return children
}

export default UnexpectedServiceErrorGuard
